export default {
  timezone: {
    type: 'string',
    required: false,
  },
  generalInterviewLimitPerDay: {
    type: 'int',
    minValue: 0,
    maxValue: 5,
    required: false,
  },
  screeningInterviewLimitPerDay: {
    type: 'int',
    minValue: 0,
    maxValue: 5,
    required: false,
  },
  technicalInterviewLimitPerDay: {
    type: 'int',
    minValue: 0,
    maxValue: 5,
    required: false,
  },
  exchangeId: {
    type: 'string',
    maxSize: 64,
    required: false,
  },
  photosIds: {
    type: 'array',
    maxSize: 1,
    required: true,
  },
  extendedInformation: {
    type: 'object',
    properties: {
      personalPhoneNumber: {
        type: 'string',
        phone: true,
        required: false,
      },
      personalEmail: {
        type: 'string',
        email: true,
        maxSize: 255,
        required: false,
      },
      birthdayCongratsConsent: {
        type: 'boolean',
        required: false,
      },
    },
  },
};
